import { __assign } from "tslib";
import React from "react";
import { Text, View } from "react-native";
import { PnmacMediaQuery, PnmacSubheading, PnmacHtmlToNative } from "pnmac-universal-components";
import { useSelector, useDispatch } from "react-redux";
import styles from "./styles";
import Payoff from "./Payoff";
import RefiLender from "./RefiLender";
import RefiPnmac from "./RefiPnmac";
import PayMortgage from "./PayMortgage";
import { Route, Switch } from 'react-router-dom';
import PayoffTitle from './PayoffTitle';
import { bindActionCreators } from "redux";
import * as Actions from "../../redux/actions/actions.js";
import { TrackerActionLID_ENUM, TrackerCategoryLID_ENUM, TrackerHitTypeLID_ENUM, UserLanguage_ENUM } from "../../redux/events/events";
import { textStyle } from '../../v2/theme';
import withPnmacTitle from '../../withPnmacTitle';
import { isSubServicingLoan } from "../../utils";
import GetPayoffStatement from "./GetPayoffStatement";
function PayoffDemands(props) {
  var _a, _b;
  var translations = useSelector(function (state) {
    return state.translations;
  });
  var currentLoanId = useSelector(function (state) {
    return state.currentLoan.loanId;
  });
  var htmlLoanIdSearchPattern = 'XXXXXXX';
  var htmlWiringInstruction = (_b = (_a = translations.WiringInstructionMsaage) === null || _a === void 0 ? void 0 : _a.replace(htmlLoanIdSearchPattern, currentLoanId)) !== null && _b !== void 0 ? _b : '';
  var layout = useSelector(function (state) {
    return state;
  });
  var isSubServicing = isSubServicingLoan(layout);
  var dispatch = useDispatch();
  var trackerDispatcher = bindActionCreators(Actions, dispatch).trackerDispatcher;
  return /*#__PURE__*/React.createElement(PnmacMediaQuery, {
    queries: {
      small: "(max-width: 599px)",
      medium: "(min-width: 600px) and (max-width: 1199px)",
      large: "(min-width: 1200px)"
    }
  }, function (matches) {
    var _a, _b;
    return /*#__PURE__*/React.createElement(View, {
      id: "main-content",
      style: styles.container
    }, /*#__PURE__*/React.createElement(View, {
      style: {
        paddingHorizontal: 10
      }
    }, /*#__PURE__*/React.createElement(View, {
      style: {
        margin: 10,
        flex: 1
      }
    }, /*#__PURE__*/React.createElement(PnmacHtmlToNative, __assign({}, props, {
      value: translations === null || translations === void 0 ? void 0 : translations.WiringInstructionMsaage
    }))), /*#__PURE__*/React.createElement(View, {
      style: {
        flexDirection: 'row',
        borderWidth: 1
      }
    }, /*#__PURE__*/React.createElement(Text, {
      style: __assign({
        margin: 10,
        flex: 1
      }, textStyle.defaultTextTitle)
    }, translations.WiringInstructionMsaageHeaderOne), /*#__PURE__*/React.createElement(View, {
      style: {
        width: 1,
        backgroundColor: 'black'
      }
    }), /*#__PURE__*/React.createElement(Text, {
      style: __assign({
        margin: 10,
        flex: 1
      }, textStyle.defaultTextTitle)
    }, translations.WiringInstructionMsaageHeaderTwo)), /*#__PURE__*/React.createElement(View, {
      style: {
        flexDirection: 'row',
        borderWidth: 1,
        borderTopWidth: 0
      }
    }, /*#__PURE__*/React.createElement(View, {
      style: {
        margin: 10,
        flex: 1
      }
    }, /*#__PURE__*/React.createElement(PnmacHtmlToNative, __assign({}, props, {
      value: (_b = (_a = translations.WiringInstructionMsaageBodyOne) === null || _a === void 0 ? void 0 : _a.replace(htmlLoanIdSearchPattern, currentLoanId)) !== null && _b !== void 0 ? _b : ''
    }))), /*#__PURE__*/React.createElement(View, {
      style: {
        width: 1,
        backgroundColor: 'black'
      }
    }), /*#__PURE__*/React.createElement(View, {
      style: {
        margin: 10,
        flex: 1
      }
    }, /*#__PURE__*/React.createElement(PnmacHtmlToNative, __assign({}, props, {
      value: translations.WiringInstructionMsaageBodyTwo
    }))))), isSubServicing ? null : /*#__PURE__*/React.createElement(PnmacSubheading, {
      "aria-role": "header",
      "aria-label": translations.ReadyPayOff,
      style: styles.subHeader
    }, translations.ReadyPayOff), isSubServicing ? /*#__PURE__*/React.createElement(GetPayoffStatement, {
      translations: translations
    }) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PayoffTitle, {
      translations: translations,
      onClick: function (title) {
        trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, title + " Tile Clicked", 0);
      }
    }), /*#__PURE__*/React.createElement(Switch, null, /*#__PURE__*/React.createElement(Route, {
      exact: true,
      path: "/Payoff/SellMyHome"
    }, /*#__PURE__*/React.createElement(RefiLender, {
      translations: translations,
      purchaseHome: true,
      zone: "sell"
    })), /*#__PURE__*/React.createElement(Route, {
      exact: true,
      path: "/Payoff/PurchaseHome"
    }, /*#__PURE__*/React.createElement(RefiLender, {
      translations: translations,
      purchaseHome: true,
      zone: "purchase"
    })), /*#__PURE__*/React.createElement(Route, {
      exact: true,
      path: "/Payoff/RefinancePennyMac/:id?/:payoffMethod?"
    }, /*#__PURE__*/React.createElement(RefiLender, {
      translations: translations
    })), /*#__PURE__*/React.createElement(Route, {
      exact: true,
      path: "/Payoff/RefinanceAnotherLender"
    }, /*#__PURE__*/React.createElement(PayMortgage, {
      translations: translations,
      payOffReason: "Refinance With Another Lender"
    })), /*#__PURE__*/React.createElement(Route, {
      exact: true,
      path: "/Payoff/PayMortgage"
    }, /*#__PURE__*/React.createElement(RefiPnmac, {
      translations: translations,
      showTop: true,
      payOffReason: "Pay Mortgage In Full"
    })), /*#__PURE__*/React.createElement(Route, {
      exact: true,
      path: '/Payoff'
    }, /*#__PURE__*/React.createElement(Payoff, {
      translations: translations,
      showImage: true,
      showKnow: true,
      small: matches.small
    })))), /*#__PURE__*/React.createElement(View, {
      style: {
        height: 40
      }
    }));
  });
}
export default withPnmacTitle(PayoffDemands, function (props) {
  var _a;
  return (_a = props.translations) === null || _a === void 0 ? void 0 : _a.PayoffResourceCenter;
}, false);